import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track", "dots"]
  static values = { interval: { type: Number, default: 6000 } }

  connect() {
    this.index = 0
    this.count = this.trackTarget.children.length
    this.renderDots()
    this.go(0)
    this.start()
    this.element.addEventListener("mouseenter", () => this.stop())
    this.element.addEventListener("mouseleave", () => this.start())
  }

  disconnect() { this.stop() }

  start() {
    if (this.timer) return
    this.timer = setInterval(() => this.next(), this.intervalValue)
  }

  stop() {
    if (this.timer) { clearInterval(this.timer); this.timer = null }
  }

  next() { this.go(this.index + 1) }
  prev() { this.go(this.index - 1) }

  go(i) {
    this.index = (i + this.count) % this.count
    this.trackTarget.style.transform = `translateX(-${this.index * 100}%)`
    if (this.hasDotsTarget) {
      Array.from(this.dotsTarget.children).forEach((dot, idx) => {
        dot.classList.toggle("bg-brand-700", idx === this.index)
        dot.classList.toggle("w-6", idx === this.index)
        dot.classList.toggle("bg-slate-300", idx !== this.index)
        dot.classList.toggle("w-2", idx !== this.index)
      })
    }
  }

  renderDots() {
    if (!this.hasDotsTarget) return
    this.dotsTarget.innerHTML = ""
    for (let i = 0; i < this.count; i++) {
      const b = document.createElement("button")
      b.type = "button"
      b.className = "h-2 rounded-full bg-slate-300 transition-all duration-300"
      b.addEventListener("click", () => { this.stop(); this.go(i); this.start() })
      this.dotsTarget.appendChild(b)
    }
  }
}
